import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { flashErrorMessage } from '../actions/flash';
import { calcConversionAmount, getCurrencySettingFormat, getDisplayCurrency } from '../utils/currencies';
import { isForeignCompany } from '../utils/companies';

class LoanAmount extends Component {
  static propTypes = {
    amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
        currencySymbol: PropTypes.string,
      }),
    }),
    format: PropTypes.string,
    precise: PropTypes.bool,
    prefix: PropTypes.node,
    percentage: PropTypes.string,
    projectCurrencies: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    currencySetting: PropTypes.shape({
      data: PropTypes.shape({
        isAbbreviationEnabled: PropTypes.bool,
        displayDecimal: PropTypes.bool,
        abbreviationDecimalPoints: PropTypes.number,
        decimalSeparator: PropTypes.string,
        thousandsSeparator: PropTypes.string,
        millionsSeparator: PropTypes.string,
        billionsSeparator: PropTypes.string,
      }),
    }),
  };
  static defaultProps = {
    precise: true,
  }
  static getPropsToState = (props) => {
    let newFormat = props.format;
    if (props.precise && props.amount) {
      const formatSplit = newFormat.split('.');
      const amountSplit = props.amount.toString().split('.');
      if (amountSplit.length > 1) {
        newFormat = `${formatSplit[0]}.${'0'.repeat(amountSplit[1].toString().length)}`;
      }
    }
    return {
      amount: props.amount,
      format: newFormat,
      prefix: props.prefix,
      projectCurrencies: props.projectCurrencies || [],
    };
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    currencySetting: state.currencySetting,
  })
  constructor(props) {
    super(props);
    const state = LoanAmount.getPropsToState(props);

    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = LoanAmount.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getConversionAmount = () => {
    const { amount, format, projectCurrencies = [] } = this.state;
    const { auth } = this.props;
    const totalAmount = amount;

    if (auth && auth.company && auth.company.countryCode && auth.company.countryCode.toLowerCase() === 'vn') {
      return this.formatAmount(amount, format);
    }

    let convertedAmount = totalAmount;
    if (auth && !isForeignCompany(auth.company)) {
      const coBaseCurrency = this.getCompanyBaseCurrency();
      const displayCurrencyCode = getDisplayCurrency();
      const companyCurrencyInProject = projectCurrencies.find(e => e.code === coBaseCurrency.code);
      const displayCurrencyInProject = projectCurrencies.find(e => e.code === displayCurrencyCode);
      const projectBaseCurrency = projectCurrencies.find(c => c.isDefault) || null;
      convertedAmount = calcConversionAmount(
        companyCurrencyInProject,
        displayCurrencyInProject,
        projectBaseCurrency,
        amount,
      );
    }
    return this.formatAmount(convertedAmount, format);
  }
  getCompanyBaseCurrency = () => {
    const { store } = this.context;
    const { companyCurrency = [] } = this.props.auth.company;
    const coDefaultCurrency = companyCurrency.find(e => e.isDefault) || {};
    if (!coDefaultCurrency) {
      store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return null;
    }
    return coDefaultCurrency;
  }

  getCurrencySymbol = () => {
    const { auth, prefix } = this.props;
    return auth && auth.company && isForeignCompany(auth.company) ? auth.company.currencySymbol : prefix;
  }

  formatAmount = (amount = '-', format, isTooltip = false) => {
    const { auth, currencySetting } = this.props;
    let loan;
    if (amount === '-') {
      return 'N/A';
    }
    const countryCode = auth && auth.company && typeof auth.company.countryCode === 'string'
      ? auth.company.countryCode.toLowerCase()
      : '';
    const isVietnam = countryCode === 'vn';
    if (isVietnam) {
      const cleanNumber = Math.round(Number(amount));

      return new Intl.NumberFormat('en-US').format(cleanNumber);
    }
    if (!isTooltip && auth && isForeignCompany(auth.company) && currencySetting.data) {
      return getCurrencySettingFormat(amount, currencySetting.data, auth.company && auth.company.countryCode);
    }
    if (format) {
      loan = numeral(amount).format(format);
    } else {
      loan = ((amount * 1) >= 1000000 && (amount * 1) < 100000000 ?
        numeral(amount).format('0.0a') :
        numeral(amount).format('0a'));
    }
    return loan;
  }

  render() {
    const { currencySetting, percentage } = this.props;
    const { amount, format } = this.state;
    const isAbbreviationEnabled = currencySetting && currencySetting.data && currencySetting.data.isAbbreviationEnabled;

    return (
      <span className="loan-amount" title={isAbbreviationEnabled ? `${this.getCurrencySymbol()}${this.formatAmount(amount, format, true)}` : null}>
        {this.getCurrencySymbol() && (
          <span className="prefix">
            {this.getCurrencySymbol()}
            {' '}
          </span>
        )}
        {this.getConversionAmount()}
        {percentage ? <span className="prefix">{percentage} </span> : null}
      </span>
    );
  }
}

export default connect(LoanAmount.mapStateToProps)(LoanAmount);



// WEBPACK FOOTER //
// ./src/components/LoanAmount.jsx